import moment from 'moment';
import { Dispatch, SetStateAction } from 'react';
import { ConfigType } from '../configuration';
import { notificationType } from '../notifications';
import { prizeDataType } from '../../pages/EditPromotion/EditPromotionPage';

export interface PrizeRatioType {
    prizeId: string;
    ratio: number;
}

export interface participationLimitsProps {
    partLimitVer?: number,
    participationLimit: number;
    participationLimitTime: number;
    participationLimitTimeZone: string;
    participationLimitCalendarDatesRange: {
        startDate: number;
        endDate: number;
    };
    participationLimitMultipleChecks: boolean;
    participationLifetimeLimit: number;
    participationLimitStartEndDatesRange: {
        startDate: number;
        endDate: number;
    };
    participationLimitCalendarDatesLimit: number;
    participationLimitCalendarDatesTimeZone: string;
    participationCalendarCycleLimit: CalendarLimit;
    minAge: number;
}

export interface winningLimitsProps {
    instantWinCalendarCycleLimit: CalendarLimit;
}

export type CalendarPeriod = 'week' | 'month' | 'year';
export type FirstDayOfWeek = 'monday' | 'sunday';

export interface CalendarLimit {
    limit: number;
    period: CalendarPeriod;
    firstDayOfWeek: FirstDayOfWeek;
}

export interface limits {
    minAge: boolean;
    calendarDay: boolean;
    rolling: boolean;
    lifetime: boolean;
    useRollingCustomDuration: boolean;
    calendarCycle: boolean;
}

export interface limitsStateValues extends ConfigType {
    tempParams: {
        limits: limits,
        alwaysWinLimits: {
            prizeOptions: Array<string>;
        };
        instantWinCalendarCycleLimitFlag?: boolean;
        winningLimitsPerTierFlag?: boolean;
        redemptionLimitsPerTierFlag?: boolean;
        instantWinLimitPerHourFlag?: boolean;
        instantWinLimitPerTimeInterval?: number;
        instantWinLimitPerTimeIntervalValue?: number;
        instantWinLimitPerConfiguration?: number;
        startDateTime?: number;
        endDateTime?: number;
    };
    alwaysWinLimits: {
        alwaysWinPrizeRatios: Array<PrizeRatioType>;
        ratioWinning: boolean;
        ratiosSum?: string;
    };
    participationLimits: participationLimitsProps;
    winningLimits: winningLimitsProps;
    selectedDateLimitOption: string;
}

export const initialValues: limitsStateValues = {
    tempParams: {
        limits: {
            minAge: false,
            calendarDay: false,
            rolling: false,
            lifetime: false,
            useRollingCustomDuration: false,
            calendarCycle: false,
        },
        alwaysWinLimits: {
            prizeOptions: [],
        },
        instantWinCalendarCycleLimitFlag: false,
    },
    promotionId: '',
    configurationId: '',
    flow: {
        flowName: {
            params: {
                partLimitVer: 1,
                winningLimitsPerPrize: {},
                winningLimitsPerTier: { '1': 2, '2': 3, '3': 5 },
                instantWinCalendarCycleLimit: {
                    limit: 1,
                    period: 'week',
                    firstDayOfWeek: 'monday'
                },
                participationLimit: 1,
                participationLimitTime: 1,
                participationLimitTimeZone: '',
                participationLimitCalendarDatesRange: {
                    startDate: parseInt(moment().format('x')),
                    endDate: parseInt(moment().add(1, 'days').format('x')),
                },
                participationLimitMultipleChecks: false,
                participationLifetimeLimit: 1,
                participationLimitStartEndDatesRange: {
                    startDate: parseInt(moment().format('x')),
                    endDate: parseInt(moment().add(1, 'days').format('x')),
                },
                participationLimitCalendarDatesLimit: 1,
                participationLimitCalendarDatesTimeZone: '',
                participationCalendarCycleLimit: {
                    limit: 1,
                    period: 'week',
                    firstDayOfWeek: 'monday'
                },
                minAge: 12,
            },
            checkerLambdas: [],
        },
    },
    participationLimits: {
        partLimitVer: 1,
        participationLimit: 1,
        participationLimitTime: 1,
        participationLimitTimeZone: '',
        participationLimitCalendarDatesRange: {
            startDate: parseInt(moment().format('x')),
            endDate: parseInt(moment().add(1, 'days').format('x')),
        },
        participationLimitMultipleChecks: false,
        participationLifetimeLimit: 1,
        participationLimitStartEndDatesRange: {
            startDate: parseInt(moment().format('x')),
            endDate: parseInt(moment().add(1, 'days').format('x')),
        },
        participationLimitCalendarDatesLimit: 1,
        participationLimitCalendarDatesTimeZone: '',
        participationCalendarCycleLimit: {
            limit: 1,
            period: 'week',
            firstDayOfWeek: 'monday'
        },
        minAge: 12,
    },
    alwaysWinLimits: {
        alwaysWinPrizeRatios: [{ prizeId: "", ratio: 0 }],
        ratioWinning: false,
    },
    winningLimits: {
        instantWinCalendarCycleLimit: {
            limit: 1,
            period: 'week',
            firstDayOfWeek: 'monday'
        }
    },
    selectedDateLimitOption: '',
};
export interface limitFlowProps {
    flowName: string
}

export interface LimitsProps {
    promotionMechanic?: string,
    config: ConfigType;
    setConfig: Dispatch<SetStateAction<ConfigType>>;
    setNotificationState: Dispatch<SetStateAction<notificationType>>;
    handleTabChange: Dispatch<SetStateAction<boolean>>;
    prizesData: Array<prizeDataType>;
    setPrizeData: (value: Array<prizeDataType>) => void;
}

export const PARTICIPATION_LIMIT_LAMBDA = 'participationLimit';
export const AGE_LIMIT_LAMBDA = 'age';
export const IW_PRIZE_LIMITS_LAMBDA = 'instantWinPrizeLimits';
